import { MOBILE_SCREENSHARE_LANDSCAPE_BODY_CLASS } from './constants';
import logger from './logger';
let activeLandscapeSource = 'none';
/**
 * 当前是否处于强制横屏（API 或 CSS）。
 *
 * @returns {boolean}
 */
export function isMobileScreenshareLandscapeActive() {
    return activeLandscapeSource !== 'none';
}
/**
 * 尝试将手机页面切到横屏：优先 fullscreen + screen.orientation.lock，失败则 CSS 旋转。
 *
 * @returns {Promise<LandscapeModeSource>}
 */
export async function enableMobileScreenshareLandscape() {
    if (activeLandscapeSource !== 'none') {
        logger.info(`[手机共享布局] 已处于横屏模式 source=${activeLandscapeSource}，跳过重复启用`);
        return activeLandscapeSource;
    }
    try {
        const root = document.documentElement;
        if (!document.fullscreenElement && typeof root.requestFullscreen === 'function') {
            logger.info('[手机共享布局] 请求全屏以便锁定屏幕方向');
            await root.requestFullscreen();
        }
        const orientation = screen.orientation;
        if (typeof orientation?.lock === 'function') {
            await orientation.lock('landscape');
            activeLandscapeSource = 'api';
            document.body.classList.remove(MOBILE_SCREENSHARE_LANDSCAPE_BODY_CLASS);
            logger.info('[手机共享布局] 已通过 Screen Orientation API 锁定横屏');
            return activeLandscapeSource;
        }
    }
    catch (error) {
        logger.warn('[手机共享布局] Orientation API 锁定横屏失败，回退 CSS 旋转', error);
    }
    document.body.classList.add(MOBILE_SCREENSHARE_LANDSCAPE_BODY_CLASS);
    activeLandscapeSource = 'css';
    logger.info('[手机共享布局] 已启用 CSS 模拟横屏');
    return activeLandscapeSource;
}
/**
 * 退出强制横屏：解锁方向、退出全屏、移除 CSS class。
 *
 * @returns {Promise<void>}
 */
export async function disableMobileScreenshareLandscape() {
    const previousSource = activeLandscapeSource;
    if (previousSource === 'none') {
        return;
    }
    document.body.classList.remove(MOBILE_SCREENSHARE_LANDSCAPE_BODY_CLASS);
    try {
        const orientation = screen.orientation;
        if (typeof orientation?.unlock === 'function') {
            orientation.unlock();
        }
    }
    catch (error) {
        logger.warn('[手机共享布局] 解锁屏幕方向失败', error);
    }
    try {
        if (document.fullscreenElement && typeof document.exitFullscreen === 'function') {
            await document.exitFullscreen();
        }
    }
    catch (error) {
        logger.warn('[手机共享布局] 退出全屏失败', error);
    }
    activeLandscapeSource = 'none';
    logger.info(`[手机共享布局] 已退出横屏模式 previousSource=${previousSource}`);
}
/**
 * 切换横/竖屏。
 *
 * @returns {Promise<boolean>} 切换后是否处于横屏。
 */
export async function toggleMobileScreenshareLandscape() {
    if (isMobileScreenshareLandscapeActive()) {
        await disableMobileScreenshareLandscape();
        return false;
    }
    await enableMobileScreenshareLandscape();
    return true;
}
